<template>
  <li
    class="relative"
    role="menuitem"
    aria-haspopup="true"
    :class="{
      'nav__nav-item nav__nav-link--dropdown': type === 'link',
      'text-white': type === 'secondary' && type === 'primary',
    }">
    <button
      @click.prevent="toggleOpen"
      @keydown.space.exact.prevent="toggleOpen"
      @keydown.esc.exact="hideDropdown"
      @keydown.up.exact.prevent="startArrowKeys"
      @keydown.down.exact.prevent="startArrowKeys"
      @keydown.right.exact.prevent="passKeyboard('nextArrow')"
      @keydown.left.exact.prevent="passKeyboard('previousArrow')"
      :class="{
        active: isActivePage(currentUrl) || isOpen,
        'nav__nav-link nav__nav-link--dropdown': type === 'link',
        'btn btn--secondary btn--nav': type === 'secondary',
        'btn btn--primary btn--nav': type === 'primary',
      }">
      <slot>Link text</slot>
    </button>
    <transition name="dropdown-fade">
      <ul
        v-if="isOpen"
        v-click-away="onClickAway"
        class="nav__menu nav__menu--dropdown"
        ref="dropdown"
        role="menu">
        <NavItem
          v-for="(link, index) in links"
          :key="index"
          @keydown.up.exact.prevent="focusPrevious(true)"
          @keydown.down.exact.prevent="focusNext(true)"
          @keydown.esc.exact="hideDropdown"
          @keydown.right.exact.prevent="passKeyboard('nextArrow')"
          @keydown.left.exact.prevent="passKeyboard('previousArrow')"
          @keydown.shift.tab="focusPrevious(false)"
          @keydown.tab.exact="focusNext(false)"
          :url="link.link"
          :currentUrl="currentUrl"
          :tag="link.tag">
          {{ link.label }}
        </NavItem>
      </ul>
    </transition>
  </li>
</template>

<script>
import NavItem from "./NavItem.vue";
import { ref, nextTick } from "vue";
import { Link } from "@inertiajs/vue3";
import { directive } from "vue3-click-away";

export default {
  components: {
    Link,
    NavItem,
  },

  directives: {
    ClickAway: directive,
  },

  emits: ["exitMenu"],

  props: {
    currentUrl: {
      type: String,
      required: false,
    },
    links: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "link",
    },
  },

  setup(props, { emit }) {
    let isOpen = ref(false);
    const dropdown = ref(null);
    let focusedIndex = 0;

    const isActivePage = (url) => {
      if (props.links.filter((e) => e.link === url).length) {
        return true;
      }
    };

    const toggleOpen = () => {
      isOpen.value = !isOpen.value;
    };

    const hideDropdown = () => {
      isOpen.value = false;
    };

    const startArrowKeys = async () => {
      if (!isOpen.value) {
        toggleOpen();
      }

      await nextTick();
      dropdown.value.children[0].children[0].focus();
    };

    const focusPrevious = (isArrowKey, index = false, length = false) => {
      if (focusedIndex == 0) {
        focusedIndex = dropdown.value.children.length - 1;
      } else {
        focusedIndex = focusedIndex - 1;
      }

      if (isArrowKey) {
        focusItem();
      }
    };

    const focusNext = (isArrowKey) => {
      focusedIndex = focusedIndex + 1;

      if (focusedIndex == dropdown.value.children.length) {
        focusedIndex = 0;
      }

      if (isArrowKey) {
        focusItem();
      }
    };

    const passKeyboard = (action) => {
      hideDropdown();
      emit("exitMenu", action);
    };

    const focusItem = () => {
      dropdown.value.children[focusedIndex].children[0].focus();
    };

    const onClickAway = (event) => {
      hideDropdown();
    };

    return {
      isOpen,
      dropdown,
      toggleOpen,
      isActivePage,
      hideDropdown,
      startArrowKeys,
      onClickAway,
      focusNext,
      focusPrevious,
      passKeyboard,
    };
  },
};
</script>
